export class QueryStringBuilder {
	private queryString: string[] = [];

	public add(key: string, value: string | number | undefined) {
		if (value) {
			this.queryString.push(`${key}=${value}`);
		}
		return this;
	}

	public build() {
		if (!this.queryString.length) {
			return '';
		}

		return `?${this.queryString.join('&')}`;
	}
}
